/**
 * ResizeObserver + echarts.resize() in the same frame can trigger
 * "ResizeObserver loop completed with undelivered notifications".
 * Defer resize to the next animation frame to avoid that.
 */
export function observeEchartsResize(element, onResize) {
  if (!element || typeof onResize !== "function") {
    return () => {};
  }

  let rafId = 0;
  const schedule = () => {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => {
      rafId = 0;
      onResize();
    });
  };

  const ro =
    typeof ResizeObserver !== "undefined"
      ? new ResizeObserver(schedule)
      : null;
  ro?.observe(element);

  return () => {
    if (rafId) cancelAnimationFrame(rafId);
    ro?.disconnect();
  };
}

/** Suppress benign ResizeObserver noise in CRA dev overlay. */
export function suppressResizeObserverLoopError() {
  const handler = (event) => {
    const msg = event?.message || "";
    if (
      msg.includes("ResizeObserver loop") ||
      msg.includes("ResizeObserver loop limit")
    ) {
      event.stopImmediatePropagation?.();
    }
  };
  window.addEventListener("error", handler);
  return () => window.removeEventListener("error", handler);
}
